"use strict";exports.__esModule=true;exports.filterType=exports.allowedCharts=void 0;var allowedCharts={Column2D:true,Line:true,Area2D:true,Bar2D:true,MSColumn2D:true,MSLine:true,MSBar2D:true,MSArea:true,StackedColumn2D:true,StackedBar2D:true,StackedArea2D:true,MSStackedColumn2D:true,MSStackedBar2D:true,MSCombi2D:true,StackedColumn2DLine:true,MSCombidy2D:true,LogMSColumn2d:true,LogMSLine:true,DragColumn:true,DragLine:true,DragArea:true},filterType={Column:"maxOnly",line:"minMax",area:"minMax"};exports.filterType=filterType;exports.allowedCharts=allowedCharts;


//////////////////
// WEBPACK FOOTER
// ./~/@fusioncharts/features/src/data-skipping/data-skipping-charts.js
// module id = 4rCM
// module chunks = 5